import styled, { keyframes } from 'styled-components'

import cloudsImage from 'assets/images/knowledge-quiz-clouds.webp'

import { Color } from 'root-constants'

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 currentColor;
  }
  70% {
    box-shadow: 0 0 0 5px transparent;
  }
  100% {
    box-shadow: 0 0 0 0 transparent;
  }
`

export const StyledKnowledgeQuizIntro = {
  Container: styled.div`
    position: relative;
    isolation: isolate;
    max-width: 440px;
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 0 24px 98px;
    margin: 0 auto;

    @media (max-height: 640px) {
      padding-bottom: 32px;
    }

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      inset: 40px 0 auto;
      aspect-ratio: 375 / 220;

      background: url(${cloudsImage}) center / 100% 100% no-repeat;
    }
  `,
  Animation: styled.div`
    width: calc(100% * 311 / 327);
    aspect-ratio: 311 / 230;
    flex-shrink: 0;

    @media (max-height: 640px) {
      height: 190px;
    }
  `,
  Title: styled.p`
    max-width: 327px;

    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 16px;
  `,
  Subtitle: styled.p`
    max-width: 327px;

    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: ${Color.INK_LIGHT};
  `,
  Loader: styled.div`
    max-width: 327px;
    width: 100%;

    padding-top: 48px;
    margin-top: auto;

    @media (max-height: 640px) {
      padding-top: 24px;
    }
  `,
  SocialProof: styled.p`
    display: flex;
    align-items: center;
    gap: 8px;

    font-size: 13px;
    font-weight: 700;
    line-height: 16px;
    color: ${Color.GREEN_DARKEST};

    background-color: ${Color.GREEN_PALE};
    border: 1px solid ${Color.GREEN_PASTEL};
    border-radius: 100px;

    padding: 8px 10px;
    margin-top: 32px;

    &::before {
      content: '';
      width: 9px;
      height: 9px;
      flex-shrink: 0;

      background-color: ${Color.GREEN_DARKEST};
      border-radius: 50%;
      animation: ${pulse} 1.5s ease-out infinite;
    }
  `,
}
